export enum GLOBAL_STYLES {
  MOBILE_HEADER_HEIGHT = "76px",
  HEADER_HEIGHT = "86px",
  MOBILE_SCREEN_WIDTH = 639,
}
